import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavigationPanelComponent } from './navigation-panel.component';
import { RpcControlsModule } from '@core-controls/controls.module';
import { NotificationsModule } from '@notifications/notifications.module';

@NgModule({
    imports: [
        CommonModule,
        RpcControlsModule,
        NotificationsModule,
        NavigationPanelComponent
    ],
    exports: [NavigationPanelComponent]
})
export class NavigationPanelModule { }
